import { getActiveProfile } from 'src/store/getters/profiles/getActiveProfile';

/**
 * finds the profile layout in the active profile, using the id
 *
 * returns the profile layout or undefined, if there are no profiles/layouts
 */
export const getProfileLayoutById = state => id =>
  getActiveProfile(state)?.layouts.find(layout => layout.id === id);
